module.exports = __webpack_public_path__ + "media/src/images/arrow_left-3320f37353f8655b249341b2d4bb1b6f.png";